__turbopack_context__.v({
  "active": "Navicon-module__L8Ejpa__active",
  "line": "Navicon-module__L8Ejpa__line",
  "navicon": "Navicon-module__L8Ejpa__navicon",
});
